import { Typography } from "antd";
import styled from "styled-components";

const { Text } = Typography;

export const DescriptionText = styled(Text)`
  margin: 0;
  font-size: 16px;
`;
